import { Modal } from "@twinkltech/curriculum-architect-component-library";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { Button, Text } from "@twinkltech/web-ui";
import { useTranslation } from "react-i18next";

import { UNSAVED_CHANGES_MODAL_NS } from "./UnsavedChangesModal.i18n";

export const UnsavedChangesModal = ({
  onClose,
  onDiscardAndLeave,
  onSaveAndLeave,
}: {
  onDiscardAndLeave: () => void;
  onSaveAndLeave: () => void;
  onClose: () => void;
}) => {
  const { t } = useTranslation(UNSAVED_CHANGES_MODAL_NS);
  const { click } = useTwinklAnalytics();

  return (
    <Modal open className="px-3 py-3" width="md" onClose={onClose}>
      <Modal.Header>
        <div className="flex flex-col gap-2">
          <Modal.Title>
            <Text variant="2xl-medium">{t("title")}</Text>
          </Modal.Title>
          <Text>{t("message")}</Text>
        </div>
      </Modal.Header>
      <Modal.Body className="mt-6 mb-8">
        <div className="flex flex-col gap-7">
          <Text as="h2" variant="xl-medium">
            What you can do now:
          </Text>
          <div>
            <Text as="h3" variant="lg-medium">
              Save changes and proceed
            </Text>
            <Text variant="base-normal">
              Save your changes and continue your navigation away from the
              planner.
            </Text>
          </div>
          <div>
            <Text as="h3" variant="lg-medium">
              Proceed without saving
            </Text>
            <Text variant="base-normal">
              Continue your navigation away from the planner without saving.
              <br />
              Your changes will not be saved.
            </Text>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-3">
        <Button
          variant="outlined"
          onClick={() => {
            click("click_cta", {
              ctaCopy: "Proceed Without Saving",
              clickLocation: "Unsaved Changes Modal",
            });
            onDiscardAndLeave();
          }}
        >
          {t("discardAndLeave")}
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            click("click_cta", {
              ctaCopy: "Keep Editing",
              clickLocation: "Unsaved Changes Modal",
            });
            onSaveAndLeave();
          }}
        >
          {t("saveAndLeave")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
